module.exports = __webpack_public_path__ + "img/wiki_button.0078b064.jpg";